import { TaskReward } from "./taskreward";

export class TaskModel {
    public readonly id: number;
    public readonly page_id: number;
    public readonly name: string;
    public readonly description: string;
    public readonly emoji: string;
    public readonly reward: TaskReward;

    public readonly type: TaskType;

    // For one-off tasks
    public readonly timeLimit: number | undefined;

    // For repeatable tasks
    public readonly minimumPerWeek: number | undefined;
    public readonly maximumPerWeek: number | undefined;

    static createOneOff(page_id: number, name: string, description: string, emoji: string, timeLimit: number, reward: TaskReward) {
        const id = Math.floor(Math.random() * 1000000);
        return { id, page_id, name, description, emoji, type: TaskType.OneOff, timeLimit, minimumPerWeek: undefined, maximumPerWeek: undefined, reward };
    }

    static createRepeatable(page_id: number, name: string, description: string, emoji: string, minimumPerWeek: number, maximumPerWeek: number, reward: TaskReward) {
        const id = Math.floor(Math.random() * 1000000);
        return { id, page_id, name, description, emoji, type: TaskType.Repeatable, timeLimit: undefined, minimumPerWeek, maximumPerWeek, reward };
    }

    constructor(id: number, page_id: number, name: string, description: string, emoji: string, type: TaskType, timeLimit: number | undefined, minimumPerWeek: number | undefined, maximumPerWeek: number | undefined, reward: TaskReward) {
        this.id = id;
        this.page_id = page_id;
        this.name = name;
        this.description = description;
        this.emoji = emoji;
        this.reward = reward;

        this.type = type;
        this.timeLimit = timeLimit;
        this.minimumPerWeek = minimumPerWeek;
        this.maximumPerWeek = maximumPerWeek;
    }
}

export enum TaskType {
    OneOff = "One Off",
    Repeatable = "Repeatable"
}